import Vue from 'vue'
import CroOrCdmoDialog from '@/components/CroOrCdmoDialog.vue'
import store from '@/store'
import i18n from '@/i18n'

const CroOrCdmoConstructor = Vue.extend(CroOrCdmoDialog)

let instance

const showCroOrCdmoDialog = function(item) {
  if (!instance) {
    instance = new CroOrCdmoConstructor({
      el: document.createElement('div'),
      store,
      i18n,
      propsData: {
        item
      }
    })
    document.body.appendChild(instance.$el)
  } else {
    instance.item = item
  }
  instance.show()
}

export default {
  install(Vue) {
    Vue.prototype.$croOrCdmo = function(item) {
      showCroOrCdmoDialog.call(this, item)
    }
  }
}